var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.loadState = void 0;
  async function loadState(client, {
    state
  }) {
    await client.request({
      method: `${client.mode}_loadState`,
      params: [state]
    });
  }
  exports.loadState = loadState;
  //# sourceMappingURL=loadState.js.map
  return exports;
}